import moment from 'moment';
import React from 'react';
import dateFormats from '../../../../../helpers/dateFormats';
// ##### 24-05-13 Komarov
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
import { setHotelDatesDivOpened } from '../../../../../Redux/actions';
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const ClickableLayer_02_StartEndDates = ({ width, height }) => {
  // ##### 24-05-10 Komarov
  const locale = useSelector(state => state.language);
  moment.locale(locale);
  // ##### Komarov 2025-08-05
  const StartDate = useLocalizedText('StartDate');
  const EndDate = useLocalizedText('EndDate');
  const stayStartDate = useSelector(state => state.hotelsContext.stayStartDate);
  const stayEndDate = useSelector(state => state.hotelsContext.stayEndDate);

  // ##### 25-05-10 Komarov
  const query = useValidateQuery();
  // ##### 24-05-13 Komarov
  const dispatch = useDispatch();
  // ##### 24-05-15 Komarov
  const onRangePickerDivClick = e => {
    dispatch(setHotelDatesDivOpened(true));
    e.stopPropagation(); // Вызываем эту функцию, чтобы событие не отлавливалось дочерними компонентами, чтобы избежать его срабатвыания два раза подряд: и на div'е, и на целевом компоненте (в данном случае - Autocomplete).
  };

  return (
    <div
      data-component="ClickableLayer_02_StartEndDates"
      style={{
        width,
        height,
        border: '#196fbb',
        borderWidth: '0.2em',
        borderStyle: 'solid',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        fontFamily: 'Arial',
        alignItems: 'center',
        margin: '0.3vw',
      }}
      id="clickableLayer_02_StartEndDates"
      onClick={e => onRangePickerDivClick(e)}
      onKeyDown={e => {
        // Trigger click action on Enter key press
        if (e.key === 'Enter') {
          onRangePickerDivClick(e);
        }
      }}
    >
      {/* ##### 22-11-02 Komarov: надпись "Заїзд -> Виїзд" */}
      <div
        style={{
          display: 'inline-flex',
          flexDirection: 'row',
          // ##### 23-03-30 Komarov
          marginTop: '0.25em',
        }}
      >
        {/* ##### 22-11-02 Komarov: надпись "Заїзд" */}
        <div>
          { /* ##### Komarov 2025-07-21 */}
          {stayStartDate ||
            (query?.start &&
              moment(query.start, dateFormats.en).format(
                dateFormats[locale]
              )) ||
            StartDate}
        </div>
        {/* ##### 22-11-02 Komarov: надпись "Заїзд -> Виїзд": стрелочка */}
        &nbsp;&nbsp;&mdash;&nbsp;&nbsp;
        {/* ##### 22-11-02 Komarov: надпись "Виїзд" */}
        <div>
          {stayEndDate ||
            (query?.end &&
              moment(query.end, dateFormats.en).format(dateFormats[locale])) ||
            EndDate}
        </div>
      </div>
    </div>
  );
};

export default ClickableLayer_02_StartEndDates;
